import { FieldConfig } from '../../common/field-types';
import {
  APVSelectFormValues,
  APV_REGIME_OPTIONS,
  GENDER_OPTIONS,
  PRIME_PERIODICITY_OPTIONS,
  SAVINGS_OPTION_OPTIONS,
  isIdealPensionMode,
  isSavingsCapacityMode,
} from './schema';

export const APV_SELECT_FIELDS: readonly FieldConfig<APVSelectFormValues>[] = [
  { key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date' },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS,
  },
  {
    key: 'net_salary', label: 'Salario neto', kind: 'number', hint: 'UF',
  },
  {
    key: 'afp_balance', label: 'Saldo AFP', kind: 'number', hint: 'UF',
  },
  {
    key: 'expected_retirement', label: 'Edad de jubilación esperada', kind: 'number', hint: 'Años',
  },
  {
    key: 'projection_rate', label: 'Tasa de proyección', kind: 'number', hint: 'Anual, ej. 0.03', step: 0.01,
  },
  {
    key: 'apv_regime', label: 'Régimen APV', kind: 'select', options: APV_REGIME_OPTIONS,
  },
  {
    key: 'savings_option', label: 'Modo de ahorro', kind: 'select', options: SAVINGS_OPTION_OPTIONS,
  },
  {
    key: 'ideal_pension', label: 'Pensión ideal', kind: 'number', hint: 'UF (solo si modo = Pensión ideal)', visibleWhen: isIdealPensionMode,
  },
  {
    key: 'agreed_premium', label: 'Prima convenida', kind: 'number', hint: 'UF (0 para no usar)', visibleWhen: isSavingsCapacityMode,
  },
  {
    key: 'payment_periodicity', label: 'Periodicidad prima', kind: 'select', options: PRIME_PERIODICITY_OPTIONS,
  },
  {
    key: 'apv_transfer_amount', label: 'Traspaso APV', kind: 'number', hint: 'UF',
  },
  {
    key: 'initial_contribution', label: 'Aporte único', kind: 'number', hint: 'UF',
  },
  {
    key: 'initial_agreed_deposit', label: 'Depósito convenido inicial', kind: 'number', hint: 'UF',
  },
  {
    key: 'annual_direct_contribution', label: 'Aporte directo anual', kind: 'number', hint: 'UF',
  },
  {
    key: 'annual_agreed_deposits', label: 'Depósitos convenidos anuales', kind: 'number', hint: 'UF',
  },
  {
    key: 'death_insured_capital', label: 'Capital muerte', kind: 'number', hint: 'UF', colClassName: 'col-md-6',
  },
  {
    key: 'accidental_death_insured_capital', label: 'Capital muerte accidental', kind: 'number', hint: 'UF', colClassName: 'col-md-6',
  },
  {
    key: 'itp_insured_capital', label: 'Capital ITP', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6',
  },
];
